function openTarget() {
  const hash = location.hash.slice(1);
  if (!hash) return;
  const target = document.getElementById(hash);
  if (!target) return;
  let node = target;
  while (node) {
    if (node.tagName && node.tagName.toLowerCase() === 'details') {
      node.open = true;
    }
    node = node.parentElement;
  }
  target.scrollIntoView();
}

function urlForCopyTrigger(el) {
  if (el.tagName && el.tagName.toLowerCase() === 'a' && el.getAttribute('href')) {
    return new URL(el.getAttribute('href'), location.href).toString();
  }
  const details = el.closest('details');
  if (details?.id) {
    return `${location.origin}${location.pathname}#${details.id}`;
  }
  return null;
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest?.('.copyurl');
  if (!trigger) return;
  event.preventDefault();
  event.stopPropagation();
  const url = urlForCopyTrigger(trigger);
  if (!url) return;
  const done = () => {
    trigger.classList.add('copied');
    setTimeout(() => trigger.classList.remove('copied'), 600);
  };
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(url).then(done, done);
  } else {
    done();
  }
});

openTarget();
window.addEventListener('hashchange', openTarget);
